<template>
  <v-card class="mx-auto mt-4 rounded-card" elevation="4" max-width="800">
    <div class="row justify-content-start">
      <div class="col-9 ml-4">
        <p
          class="title font-weight-bold text-truncate text-wrap"
          style="color: black"
        >
          {{ this.body }}
        </p>
      </div>
      <div class="row-2 ml-7">
        <v-btn icon color="primary">
          <v-icon class="ma-2" @click="editAnnouncement"> mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon color="red">
          <v-icon class="ma-2" @click="removeAnnouncement">
            mdi-delete</v-icon
          ></v-btn
        >
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-start">
        <div class="ml-4">
          <v-icon> mdi-calendar</v-icon>
          <label> {{ this.date }} </label>
        </div>
      </div>
      <!-- <div class="row justify-content-start">
        <div class="ml-4">
          <v-icon> mdi-web-clock</v-icon>
          <label> {{ this.time }} </label>
        </div>
      </div> -->
      <div class="row justify-content-start">
        <v-card-subtitle
          ><span class="font-weight-black"> Source:</span> {{ this.source }}
        </v-card-subtitle>
      </div>
      <div class="row justify-content-start ml-1">
        <!-- <v-card-subtitle> Type:  </v-card-subtitle> -->
        <v-chip
          style="color: white"
          class="ma-2"
          :color="chipsColor(this.type)"
        >
          {{ typeMessage }}
        </v-chip>
      </div>

      <p style="color: #000" class="text-wrap">
        <span class="font-weight-black">Reference:</span> {{ this.reference }}
      </p>
    </div>

    <v-card-text class="text-truncate">
      {{ this.body }}
    </v-card-text>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <v-btn @click="show = !show" color="blueblack" text>
            <label>
              {{ show ? "Less" : "More" }}
            </label>
          </v-btn>

          <v-btn icon @click="show = !show">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>

        <v-card-text>
          {{ this.body }}
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import { eventBus } from "@/main.js";
export default {
  computed: {
    ...mapFields("announcement", ["allAnnouncements"]),
    typeMessage() {
      if (this.type === 0) {
        return "Info";
      } else {
        return "Warning";
      }
    },
  },
  data: () => ({
    show: false,
  }),
  methods: {
    ...mapActions("announcement", ["updateAnnouncement", "deleteAnnouncement"]),
    ...mapActions("shared", ["populateForm", "showEditForm"]),
    chipsColor(type) {
      if (type === 0) {
        return "primary";
      } else {
        return "orange";
      }
    },
    editAnnouncement() {
      // get the document to be edited
      // verified/fake
      var found;
      found = this.allAnnouncements.find((element) => element.id === this.id);

      this.populateForm({
        payload: {
          formdata: {
            id: found.id,
            body: found.content.message_en,
            date: found.content.date,
            source: found.content.source,
            type: found.content.type,
          },
        },
      });
      // set the form as Edit form
      this.showEditForm({
        payload: {
          isEdit: true,
        },
      });
      eventBus.$emit("formChangeEvent", true);
      eventBus.$emit("dialogToggle", true);
    },
    async removeAnnouncement() {
      // get the document to be delted
      // verified/fake
      var found;
      found = this.allAnnouncements.find((element) => element.id === this.id);

      try {
        await this.deleteAnnouncement({
          payloadId: found.id,
        });

        alert("Successfully Deleted News!");
        location.reload();
      } catch (error) {
        alert("Failed to delete News!");
      }
    },
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    reference: {
      type: String,
      required: false,
    },
    source: {
      type: String,
      required: false,
    },
    body: {
      type: String,
      required: true,
    },
  },
};
</script>